import { IPublicDesktopV1FiltersGetMetaResponse } from 'shared/repositories/commercial-search-offers/desktop/v1/filters/get-meta';

export function dataFromFetchOffersSearchMetaSelector(
  state: IPublicDesktopV1FiltersGetMetaResponse,
): IPublicDesktopV1FiltersGetMetaResponse['data'] {
  return state.data;
}
